/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import klass from"../../base/klass";import IStorage from"../../interfaces/Storage";export default klass.create([IStorage],{},{set(){},get(){},unset(){},clear(){}});